<div
    class="panel panel-default"
    [ngClass]="{'filter-panel': topPanel}"
>
    <div class="panel-body">
        <form
            name="filter-sort-form"
            class="row justify-content-center"
        >
            <div
                *ngIf="brandId === BrandEnum.CELPIP"
                class="col-md-12"
            >
                <label>Filter by:</label>
                <select
                    name="filter"
                    class="form-control"
                    [(ngModel)]="filterSortData.filter"
                    (change)="changeFilter()"
                >
                    <option
                        *ngFor="let opt of productShoppingFilters"
                        [ngValue]="opt.value"
                    >
                        {{opt.title}}
                    </option>
                </select>
            </div>
            <!-- remove this by TEC-14124
            <div [ngClass]="{'col-md-4': brandId === BrandEnum.CELPIP, 'col-md-6': brandId === BrandEnum.CAEL }">
                <label>Sort by:</label>
                <select
                    name="sort"
                    class="form-control"
                    [(ngModel)]="filterSortData.sort"
                    (change)="changeSort()"
                >
                    <option
                        *ngFor="let opt of productSortTypeOrder"
                        [ngValue]="opt.value"
                    >
                        {{opt.title}}
                    </option>
                </select>
            </div>
          -->
        </form>
    </div>
</div>
